// extracted by mini-css-extract-plugin
export default {"topicContainer":"TopPickLinkItem_topicContainer__IhL0T","topic":"TopPickLinkItem_topic__7ayf+"};